import "./styles.scss";

import { FaSync } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { firstLastName } from "../../utils/utils";
import { decryptIfEncrypted } from "../../utils/fieldDecryptor";
import avatar from "../../assets/images/profile/img_placeholder.svg";
import { getFormDashboard, loadUserStorage } from "../../store/middleware";

const AvatarHome = ({ buttonUpdate = false }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);

  const handleUpdate = () => {
    dispatch(loadUserStorage(true, false, "AvatarHome"));
    dispatch(getFormDashboard({ status: ["'pendent'", "'pendent-delayed'"] }, false));
  };

  return (
    <div className="avatarHomeContainer">
      <div className="avatarHomeContent">
        <div className="avatarHomePhoto">
          <img alt="Avatar" src={user?.picture ?? avatar} />
        </div>

        <div className={`avatarHomeWrapperTitle ${buttonUpdate ? "withButtonUpdate" : ""}`.trim()}>
          <div>
            <h1 className="avatarHomeTitle">
              {t("BTN_HELLO")}, <strong>{firstLastName(decryptIfEncrypted(user.name))}</strong>
            </h1>

            {user?.role === "teacher" && <div className="avatarHomeSubTitle">{t("CARD_CLASS_TEACHER")}</div>}
            {user?.role === "customerService" && <div className="avatarHomeSubTitle">Customer Service</div>}
            {user.role === "companyManager" && <div className="avatarHomeSubTitle">Company Manager</div>}
          </div>

          {buttonUpdate && (
            <button className="avatarHomeButtonUpdate" onClick={handleUpdate}>
              <FaSync color="#004fff" />
              {t("UPDATE_SCREEN")}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AvatarHome;
